import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';

import { environment } from '@env/environment';
import { I18nService } from '@app/i18n';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ZendeskService } from '@shared/services/zendesk.service';
import { RouteData } from '@app/app-routing.module';
import { merge, Observable } from 'rxjs';
import { AnalyticsService } from '@shared/services/analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private destroyRef: DestroyRef = inject(DestroyRef);

  constructor(
    private analyticsService: AnalyticsService,
    private activatedRoute: ActivatedRoute,
    private i18nService: I18nService,
    private router: Router,
    private titleService: Title,
    private zendeskService: ZendeskService,
  ) {
    this.zendeskService.initZendesk();
  }

  public async ngOnInit(): Promise<void> {
    // Setup translations
    this.i18nService.init(environment.defaultLanguage, environment.supportedLanguages);

    this.analyticsService.initialize();
    // this.analyticsService.trackEvent('test', 'APP is loaded', 'EVENT HAPPENED');

    const onNavigationEnd: Observable<any> = this.router.events.pipe(
      filter((event) => {
        return event instanceof NavigationEnd;
      }),
    );

    // Change page title on route change
    merge(onNavigationEnd)
      .pipe(
        map(() => {
          let route: ActivatedRoute = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route: ActivatedRoute): boolean => route.outlet === 'primary'),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(async (route: ActivatedRoute): Promise<void> => {
        const routeData: RouteData = route.data;
        this.zendeskService.showWidget();
        const pageTitle: string = routeData.title ? this.i18nService.translate(routeData.title) : 'Potentialife';
        this.titleService.setTitle(pageTitle);
      });
  }
}
